import React, { Component } from 'react';
import { Row, Col, Table } from 'antd';
import moment from 'moment';

class PrintOrderSheet extends Component {
    state = {
        taskData: [
            {
                id: '1', task: 'Medicine Qty + exp date + Cutting Sample (if needed?) + Packet -> BKT + Flat Tabs (if needed?)', responsibility: 'Sonu', by: '',
            },
            {
                id: '2', task: 'Cutting', responsibility: '', by: '',
            },
            {
                id: '3', task: 'QC', responsibility: 'Ravindra', by: '',
            },
            {
                id: '4', task: 'BKT -> SKT', responsibility: 'Ravindra', by: '',
            },
            {
                id: '5', task: 'QC', responsibility: 'Sonu', by: '',
            },
            {
                id: '6', task: 'SKT -> Pouch', responsibility: 'Ravindra', by: '',
            },
            {
                id: '7', task: 'Sealing + Cutting + Labelling', responsibility: 'Ravindra', by: '',
            },
            {
                id: '8', task: 'QC', responsibility: 'Akanksha', by: '',
            },
            {
                id: '9', task: 'CAREFILLING + White Box/Dispenser', responsibility: 'Sonu', by: '',
            },
            {
                id: '10', task: 'Dispatch', responsibility: 'Sonu', by: '',
            },
        ],
    };

    render() {
        const {
            generateData, info, refillStartDate, refillDuration, refillLength,
        } = this.props;

        // console.log(refillLength);

        const length = generateData.length > 0 ? Object.keys(generateData[0]).length : 0;
        let column1 = [];
        let column2 = [];
        let column3 = [];

        if (length <= 4) {
            column1 = [];

            for (let i = 0; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    className: 'indColumn',
                    // style: { fontSize: '30px' },

                    align: 'center',
                };
                // console.log('yes');
                column1.push(val);
                // console.log(column1);
            }
        } else if (length >= 5 && length <= 8) {
            column1 = [];
            column2 = [];
            // console.log(10);

            for (let i = 0; i < 4; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    className: 'indColumn',
                };
                // console.log('yes');
                column1.push(val);
            }

            for (let i = 4; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    className: 'indColumn',
                };
                // console.log('yes');
                column2.push(val);
                // console.log(column1);
                // console.log(column2);
            }
        } else if (length >= 9 && length <= 12) {
            column1 = [];
            column2 = [];
            column3 = [];
            // console.log(15);

            for (let i = 0; i < 4; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    className: 'indColumn',
                };
                // console.log('yes');
                column1.push(val);
            }

            for (let i = 4; i < 8; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    className: 'indColumn',
                };
                // console.log('yes');
                column2.push(val);
            }

            for (let i = 8; i < length; i++) {
                const val = {
                    title: `Dose ${i + 1}`,
                    key: `key${i + 1}`,
                    dataIndex: `key${i + 1}`,
                    align: 'center',
                    className: 'indColumn',
                };
                // console.log('yes');
                column3.push(val);
            }
        }

        return (
            <div id="print-content" style={{ display: 'none' }}>
                <div style={{ textAlign: 'center' }}>
                    <Row type="flex" justify="space-around">
                        <Col span={8}>
                            <p style={{ color: 'black' }}>Order/Refill ID - {info.id}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>
                                Patient Name - {info.user === undefined ? null : `${info.user.first_name} ${info.user.last_name}`}
                                {refillLength > 1 ? ' (Repeat)' : ' (New)'}
                            </p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Mobile – Contact Number - {info.user === undefined ? null : `${info.user.mobile_number} – ${info.user.contact_number}`}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Partner Name + Location - {info.partner === undefined ? null : `${info.partner_location.name}`}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Doctor's Name - {JSON.stringify(info.doctors)}</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Start Date - {moment(refillStartDate).format('DD-MM-YYYY')} ({moment(refillStartDate).format('dddd')})</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Refill Cycle Tenure - {refillDuration} Days</p>
                        </Col>

                        <Col span={8}>
                            <p style={{ color: 'black' }}>Dispenser Size - {info.dispenser_size === undefined ? '' : info.dispenser_size}</p>
                        </Col>
                    </Row>
                </div>

                <hr />

                <h6 style={{ textAlign: 'center' }}>Dose information</h6>

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    columns={column1}
                    bordered
                    size="small"
                    style={{ whiteSpace: 'pre', outline: '1px solid black', fontSize: '7px' }}
                />

                <br />

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    size="small"
                    columns={column2}
                    bordered
                    style={{ whiteSpace: 'pre', outline: length <= 4 ? '' : '1px solid black', fontSize: '7px' }}
                />

                <br />

                <Table
                    pagination={false}
                    dataSource={generateData}
                    className="printHead"
                    rowClassName="printColumn"
                    size="small"
                    columns={column3}
                    bordered
                    style={{ whiteSpace: 'pre', outline: length <= 8 ? '' : '1px solid black', fontSize: '7px' }}
                />
            </div>
        );
    }
}

export default PrintOrderSheet;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/PrintOrderSheet.js